var currentWidth = window.innerWidth;
//var maxSlideWidth = currentWidth >= 992 ? 33 : 15;
var maxSlideWidth = currentWidth >= 992 ? 45 : 30;
jQuery(document).ready(function($){

    $('.manual-slider-image').each( function() {
        var cur = $(this);
        // Adjust the slider
        var width = cur.outerWidth()+'px';
        cur.find('.resize-comparison').css({'width': width})
        var height = cur.outerHeight()+'px';
        cur.find('.resize-comparison').css({'height': height})
        // Bind dragging events
        drags(cur.find('.handle'), cur.find('.resize'), cur);
    });

    $('body').on('click',' img.image-before', function () {
        var currentImage = $('img.image-before');
        var nextImage = $('img.image-after');
        currentImage.css({'display':'none','visibility':'hidden'});
        currentImage.removeClass('image-before').addClass('image-after');
        nextImage.css({'display':'block','visibility':'visible'});
        nextImage.addClass('image-before').removeClass('image-after');
    });

    $(window).resize(function(){
        $('.manual-slider-image').each(function(){
            var cur = $(this);
            var width = cur.width()+'px';
            cur.find('.resize-comparison').css({'width':width});
            var height = cur.outerHeight()+'px';
            cur.find('.resize-comparison').css({'height':height});
        });
        currentWidth = window.innerWidth;
        maxSlideWidth = currentWidth >= 992 ? 45 : 30;
    });

    function drags(dragElement, resizeElement, container) {
        var dragElementParents = dragElement.parents();
        // Initialize the dragging event on mousedown.
        dragElement.on('mousedown touchstart', function(e) {
            dragElement.addClass('draggable');
            resizeElement.addClass('resizable');
            // Check if it's a mouse or touch event and pass along the correct value
            var startX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;
            // Get the initial position
            var dragWidth = dragElement.outerWidth(),
            posX = dragElement.offset().left + dragWidth - startX,
            containerOffset = container.offset().left,
            containerWidth = container.outerWidth();
            // Set limits
            var minLeft = containerOffset + maxSlideWidth;
            var maxLeft = containerOffset + containerWidth - dragWidth - maxSlideWidth;
            // Calculate the dragging distance on mousemove.
            dragElementParents.on("mousemove touchmove", function(e) {
                // Check if it's a mouse or touch event and pass along the correct value
                var moveX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;
                var leftValue = moveX + posX - dragWidth;
                // Prevent going off limits
                if ( leftValue < minLeft) {
                    leftValue = minLeft;
                } else if (leftValue > maxLeft) {
                    leftValue = maxLeft;
                }
                // Translate the handle's left value to masked divs width.
                var widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth;
                // Set the new values for the slider and the handle.
                // Bind mouseup events to stop dragging.
                $('.draggable').css('left', widthValue+'%').on('mouseup touchend touchcancel', function (e) {
                    $(this).removeClass('draggable');
                    resizeElement.removeClass('resizable');
                });
                $('.resizable').css('width', widthValue+'%');
            }).on('mouseup touchend touchcancel', function(){
                dragElement.removeClass('draggable');
                resizeElement.removeClass('resizable');
            });
            e.preventDefault();
        }).on('mouseup touchend touchcancel', function(e){
            dragElement.removeClass('draggable');
            resizeElement.removeClass('resizable');
        });
    }

});    